import type { CompletePasswordResetPayload } from '../models/complete-password-reset-payload';
import type { CompletePasswordResetPayloadDto } from '../dto/complete-password-reset-payload-dto';

export function mapCompletePasswordResetPayloadToDto(
  payload: CompletePasswordResetPayload,
): CompletePasswordResetPayloadDto {
  return {
    email: payload.email,
    code: payload.code,
    password: payload.password,
    password_confirmation: payload.passwordConfirmation,
  };
}
